export default "/images/c0c469c99caea3895156c647b354aa23.avif";